import { Issue } from "@adsk/acc-issues-types";

export const is3dIssue = (issue: Pick<Issue, "linkedDocuments">): boolean => {
  return issue.linkedDocuments?.[0]?.type === "TwoDVectorPushpin";
};
export const is2dFileIssue = (
  issue: Pick<Issue, "linkedDocuments">
): boolean => {
  return issue.linkedDocuments?.[0]?.type === "TwoDRasterPushpin";
};
